import { c as _c } from "react/compiler-runtime";
import { getPricingConfig } from "@/server/shop/get-shop-config";
export default function ProductPrice(t0) {
  const $ = _c(50);
  const {
    product
  } = t0;
  const basePrice = product?.variants?.[0]?.price || 0;
  const comparePrice = product?.variants?.[0]?.compareprice || 0;
  product?.variants?.[0]?.display_price || 0;
  const priceInclVat = product?.variants?.[0]?.price_incl_vat || 0;
  const priceExclVat = product?.variants?.[0]?.price_excl_vat || 0;
  const {
    showVatBreakdown,
    vatDisplayFormat
  } = getPricingConfig();
  if (!showVatBreakdown) {
    let t1;
    if ($[0] !== basePrice) {
      t1 = basePrice.toFixed(2) ?? 0;
      $[0] = basePrice;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <span className="text-base lg:text-lg">£{t1}</span>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== basePrice || $[5] !== comparePrice) {
      t3 = comparePrice > basePrice && <><del className="text-sm text-slate-700 ms-2">£{comparePrice.toFixed(2)}</del></>;
      $[4] = basePrice;
      $[5] = comparePrice;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
      t4 = <div className="price font-bold text-red-700 text-center">{t2}{t3}</div>;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (vatDisplayFormat === "excl") {
    let t1;
    if ($[10] !== priceExclVat) {
      t1 = priceExclVat.toFixed(2);
      $[10] = priceExclVat;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    let t2;
    if ($[12] !== t1) {
      t2 = <span className="leading-none font-bold text-red-700 text-base lg:text-lg">£{t1}</span>;
      $[12] = t1;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="bg-gray-100 border border-gray-400 inline-flex font-bold tracking-wide text-[10px] leading-tight px-1 rounded">excl. VAT</span>;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] !== basePrice || $[16] !== comparePrice) {
      t4 = comparePrice > basePrice && <><del className="text-xs text-slate-700 font-semibold">£{comparePrice.toFixed(2)}</del></>;
      $[15] = basePrice;
      $[16] = comparePrice;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    let t5;
    if ($[18] !== t2 || $[19] !== t4) {
      t5 = <div className="my-1"><div className="flex items-end justify-center gap-1">{t2}{t3}{t4}</div></div>;
      $[18] = t2;
      $[19] = t4;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    return t5;
  }
  if (vatDisplayFormat === "incl") {
    let t1;
    if ($[21] !== priceInclVat) {
      t1 = priceInclVat.toFixed(2);
      $[21] = priceInclVat;
      $[22] = t1;
    } else {
      t1 = $[22];
    }
    let t2;
    if ($[23] !== t1) {
      t2 = <span className="leading-none font-bold text-red-700 text-base lg:text-lg">£{t1}</span>;
      $[23] = t1;
      $[24] = t2;
    } else {
      t2 = $[24];
    }
    let t3;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span className="bg-gray-100 border border-gray-400 inline-flex font-bold tracking-wide text-[10px] leading-tight px-1 rounded">incl. VAT</span>;
      $[25] = t3;
    } else {
      t3 = $[25];
    }
    let t4;
    if ($[26] !== basePrice || $[27] !== comparePrice) {
      t4 = comparePrice > basePrice && <><del className="text-xs text-slate-700 font-semibold">£{comparePrice.toFixed(2)}</del></>;
      $[26] = basePrice;
      $[27] = comparePrice;
      $[28] = t4;
    } else {
      t4 = $[28];
    }
    let t5;
    if ($[29] !== t2 || $[30] !== t4) {
      t5 = <div className="my-1"><div className="flex items-end justify-center gap-1">{t2}{t3}{t4}</div></div>;
      $[29] = t2;
      $[30] = t4;
      $[31] = t5;
    } else {
      t5 = $[31];
    }
    return t5;
  }
  let t1;
  if ($[32] !== priceExclVat) {
    t1 = priceExclVat.toFixed(2);
    $[32] = priceExclVat;
    $[33] = t1;
  } else {
    t1 = $[33];
  }
  let t2;
  if ($[34] !== t1) {
    t2 = <span className="leading-none font-bold text-red-700 text-base lg:text-lg">£{t1}</span>;
    $[34] = t1;
    $[35] = t2;
  } else {
    t2 = $[35];
  }
  let t3;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="bg-gray-100 border border-gray-400 inline-flex font-bold tracking-wide text-[10px] leading-tight px-1 rounded">excl. VAT</span>;
    $[36] = t3;
  } else {
    t3 = $[36];
  }
  let t4;
  if ($[37] !== basePrice || $[38] !== comparePrice) {
    t4 = comparePrice > basePrice && <><del className="text-xs text-slate-700 font-semibold">£{comparePrice.toFixed(2)}</del></>;
    $[37] = basePrice;
    $[38] = comparePrice;
    $[39] = t4;
  } else {
    t4 = $[39];
  }
  let t5;
  if ($[40] !== t2 || $[41] !== t4) {
    t5 = <div className="flex items-end justify-center gap-1">{t2}{t3}{t4}</div>;
    $[40] = t2;
    $[41] = t4;
    $[42] = t5;
  } else {
    t5 = $[42];
  }
  let t6;
  if ($[43] !== priceInclVat) {
    t6 = priceInclVat.toFixed(2);
    $[43] = priceInclVat;
    $[44] = t6;
  } else {
    t6 = $[44];
  }
  let t7;
  if ($[45] !== t6) {
    t7 = <div className="text-xs mt-1 font-semibold opacity-70 tracking-wide">£{t6} incl. VAT</div>;
    $[45] = t6;
    $[46] = t7;
  } else {
    t7 = $[46];
  }
  let t8;
  if ($[47] !== t5 || $[48] !== t7) {
    t8 = <div className="my-1 text-center">{t5}{t7}</div>;
    $[47] = t5;
    $[48] = t7;
    $[49] = t8;
  } else {
    t8 = $[49];
  }
  return t8;
}